var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyToClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 2.00002C2.66667 1.64852 2.78674 1.3038 3.04526 1.04528C3.30378 0.786763 3.6485 0.666687 4 0.666687H8C8.3515 0.666687 8.69622 0.786763 8.95474 1.04528C9.21326 1.3038 9.33333 1.64852 9.33333 2.00002H10C11.1015 2.00002 12 2.8985 12 4.00002V13.3334C12 14.4349 11.1015 15.3334 10 15.3334H2C0.898477 15.3334 0 14.4349 0 13.3334V4.00002C0 2.8985 0.898477 2.00002 2 2.00002H2.66667ZM4 2.00002H8V3.33335H4V2.00002ZM9.33333 3.33335C9.33333 3.68485 9.21326 4.02957 8.95474 4.28809C8.69622 4.54661 8.3515 4.66669 8 4.66669H4C3.6485 4.66669 3.30378 4.54661 3.04526 4.28809C2.78674 4.02957 2.66667 3.68485 2.66667 3.33335H2C1.63486 3.33335 1.33333 3.63488 1.33333 4.00002V13.3334C1.33333 13.6985 1.63486 14 2 14H10C10.3651 14 10.6667 13.6985 10.6667 13.3334V4.00002C10.6667 3.63488 10.3651 3.33335 10 3.33335H9.33333Z",
    fill: "url(#paint0_linear_318_4700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_4700",
    x1: 6.09524,
    y1: -4.68781,
    x2: 5.95297,
    y2: 15.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClip);
export default __webpack_public_path__ + "static/media/copyToClip.ff6dba69.svg";
export { ForwardRef as ReactComponent };